import { FC, PropsWithChildren, ReactNode, useCallback } from 'react';
import { FormValidationAlert } from '../../../common/form/alerts/FormValidationAlert';
import { ValidationMessagesMap } from '../../../common/utils/ValidationMessagesMap';
import { i18nNsFactory } from '@atlas-frontend/i18n';
import translations from './BrokenReferencesAlertWithDrawer.translations.json';

const { addTranslations, useTranslation } = i18nNsFactory(
  'broken-references-alert-with-drawer',
);
addTranslations(translations);

export interface BrokenReferencesAlertWithDrawerProps
  extends PropsWithChildren {
  brokenReferencesMap?: ValidationMessagesMap;
  tLabel: (name: string | string[]) => ReactNode;
}

export const BrokenReferencesAlertWithDrawer: FC<
  BrokenReferencesAlertWithDrawerProps
> = (props) => {
  const { brokenReferencesMap, tLabel, ...rest } = props;
  const { t } = useTranslation();

  const tBrokenReferenceLabel = useCallback(
    (fieldNames: string | string[]) =>
      tLabel([fieldNames].flat().map((fieldName) => `algorithms.${fieldName}`)),
    [tLabel],
  );

  if (!brokenReferencesMap) {
    return null;
  }

  return (
    <FormValidationAlert
      validationMessagesMap={brokenReferencesMap}
      tLabel={tBrokenReferenceLabel}
      message={t('alert.message', { count: brokenReferencesMap.size })}
      {...rest}
    />
  );
};
